import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCard"] */ "/app/src/components/product/ProductCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product/ProductDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product/RecentlyViewedTracker.tsx");
